import { createAction, emptyProps, props } from "@ngrx/store";
import { ITopGroup } from "../../services/api-services/installations/response/top-group.response";
import { InstallationMenuItemNew } from "../../shared/sidebar/sidebar-installations-menu/models/installation-menu-item.model";
import { IProductConfigurationHeaderResponse } from "../../services/api-services/product-configuration/models/product-configuration-headers.model";

export namespace InstallationActions {
    export const getActiveInstallationDetails = createAction(
        "[InstallationActions] get active installation details",
        props<{ refCode: string }>()
    )
    export const getActiveInstallationDetailsSuccess = createAction(
        "[InstallationActions]  get active installation details success",
        props<{ installation: InstallationMenuItemNew }>()
    )
    export const getActiveInstallationDetailsFailed = createAction(
        "[InstallationActions] get active installation details failed",
        props<{ error: string }>(),
    )
    /** Quiet refresh after a tree edit: replaces the details only - no clearing and no
     *  top-group re-derivation (the installations menu may be browsing another top group). */
    export const refreshActiveInstallationDetailsSuccess = createAction(
        "[InstallationActions] refresh active installation details success",
        props<{ installation: InstallationMenuItemNew }>()
    )

    // Get latest installations
    export const getLatestInstallations = createAction(
        "[InstallationActions] get latest installations",
        emptyProps
    )
    export const getLatestInstallationsSuccess = createAction(
        "[InstallationActions] get latest installations success",
        props<{ installations: InstallationMenuItemNew[] }>(),
    )
    export const getLatestInstallationsFailed = createAction(
        "[InstallationActions] get latest installations failed",
        props<{ error: string }>(),
    )
    // Add latest installation
    export const addLatestInstallation = createAction(
        "[InstallationActions] add latest installation",
        props<{ refCode: string }>()
    )
    export const addLatestInstallationSuccess = createAction(
        "[InstallationActions] add latest installation success",
        props<{ installations: InstallationMenuItemNew[] }>()
    )

    // Set at topgroup on menu change, we don't want to wait for a callback before getting installations
    export const setSelectedTopGroup = createAction("[InstallationActions] preset Selected TopGroup",
        props<{ selectedTopGroup: ITopGroup }>()
    )

    export const presetSelectedTopGroupRefCode = createAction("[InstallationActions] preset Selected TopGroup refCode",
        props<{ selectedTopGroupRefCode: string }>()
    )
    export const resetSelectedTopGroup = createAction("[InstallationActions] Reset Selected TopGroup",
        props<{ resetSelectedTopGroup: ITopGroup | undefined }>()
    )
    export const setProductConfigurationHeaders = createAction("[InstallationActions] Set ProductConfiguration Headers",
        props<{ headers: IProductConfigurationHeaderResponse[] | undefined |null }>()
    )
}